(() => {
  if (window.__abZendeskCustomLauncherInit) return;
  window.__abZendeskCustomLauncherInit = true;

  const cfg = window.__AB_ZENDESK_LAUNCHER__ || {};
  const iconUrl = cfg.iconUrl;
  if (!iconUrl) return;

  let button;
  let messengerWired;
  let messengerPanelOpen = false;
  let webWidgetPanelOpen = false;
  let resizeScheduled;
  let lastUnreadCount = 0;

  const widgetGap =
    typeof cfg.widgetGapAboveLauncher === 'number' ? cfg.widgetGapAboveLauncher : 5;

  function getLauncherRect() {
    const launcher = document.getElementById('ab-zendesk-custom-launcher');
    return launcher ? launcher.getBoundingClientRect() : null;
  }

  function forEachZendeskChatFrame(callback) {
    const rect = getLauncherRect();
    if (!rect) return;
    document.querySelectorAll('iframe').forEach(function (frame) {
      if (frame.id === 'launcher') return;
      const cs = window.getComputedStyle(frame);
      if (cs.position !== 'fixed') return;
      const br = frame.getBoundingClientRect();
      if (br.width < 200 || br.height < 200) return;
      if (Math.abs(window.innerWidth - br.right - (window.innerWidth - rect.right)) > 120) return;
      callback(frame, br, rect);
    });
  }

  function hasZendeskChatFrameCandidate() {
    let found = false;
    forEachZendeskChatFrame(function () {
      found = true;
    });
    return found;
  }

  function ensureStyles() {
    if (document.getElementById('ab-zendesk-launcher-styles')) return;
    const openFaceBg = cfg.openFaceBg || '#e32619';
    const s = document.createElement('style');
    s.id = 'ab-zendesk-launcher-styles';
    s.textContent =
      '#ab-zendesk-custom-launcher{position:fixed;bottom:24px;right:24px;z-index:999998;width:60px;height:60px;padding:0;border:0;border-radius:0;cursor:pointer;overflow:hidden;}' +
      '#ab-zendesk-custom-launcher:focus-visible{outline:2px solid currentColor;outline-offset:3px;}' +
      '#ab-zendesk-custom-launcher .ab-zendesk-launcher-face{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;border-radius:9999px;}' +
      '#ab-zendesk-custom-launcher .ab-zendesk-launcher-face--toggle{display:none;background:' +
      openFaceBg +
      ';}' +
      '#ab-zendesk-custom-launcher[aria-expanded="true"] .ab-zendesk-launcher-face--chat{display:none;}' +
      '#ab-zendesk-custom-launcher[aria-expanded="true"] .ab-zendesk-launcher-face--toggle{display:flex;}' +
      '#ab-zendesk-custom-launcher img{display:block;width:100%;height:100%;object-fit:cover;border-radius:9999px;}' +
      '#ab-zendesk-custom-launcher .ab-zendesk-launcher-face--toggle svg{flex-shrink:0;}' +
      '#ab-zendesk-custom-launcher .ab-zendesk-unread-badge{position:absolute;top:0px;right:0px;z-index:1;min-width:1.25rem;height:1.25rem;padding:0 .35rem;border-radius:9999px;background:#80251e;color:#fff;font:600 .75rem/1.25rem system-ui,sans-serif;text-align:center;box-sizing:border-box;}';
    document.head.appendChild(s);
  }

  function clearMessengerFrameBottom() {
    document.querySelectorAll('iframe[data-ab-zd-offset]').forEach(function (frame) {
      frame.style.removeProperty('bottom');
      frame.removeAttribute('data-ab-zd-offset');
    });
  }

  function applyMessengerFrameBottom() {
    const rect = getLauncherRect();
    if (!rect) return;
    const bottomPx = Math.max(0, Math.round(window.innerHeight - rect.top + widgetGap));
    forEachZendeskChatFrame(function (frame) {
      frame.style.setProperty('bottom', bottomPx + 'px', 'important');
      frame.setAttribute('data-ab-zd-offset', '1');
    });
  }

  function scheduleApplyFrameBottom() {
    applyMessengerFrameBottom();
    window.setTimeout(applyMessengerFrameBottom, 50);
    window.setTimeout(applyMessengerFrameBottom, 200);
    window.setTimeout(applyMessengerFrameBottom, 600);
    window.setTimeout(applyMessengerFrameBottom, 1200);
    window.setTimeout(applyMessengerFrameBottom, 2500);
    window.setTimeout(applyMessengerFrameBottom, 4000);
  }

  function onViewportResizeForFrame() {
    if (
      !messengerPanelOpen &&
      !webWidgetPanelOpen &&
      !hasZendeskChatFrameCandidate() &&
      !document.querySelector('iframe[data-ab-zd-offset]')
    ) {
      return;
    }
    if (resizeScheduled) return;
    resizeScheduled = true;
    window.requestAnimationFrame(function () {
      resizeScheduled = false;
      applyMessengerFrameBottom();
    });
  }

  function refreshUnreadBadge() {
    if (!button) return;
    const chatClosed = !messengerPanelOpen && !webWidgetPanelOpen;
    const n = lastUnreadCount;
    let badge = button.querySelector('.ab-zendesk-unread-badge');
    if (n > 0 && chatClosed) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ab-zendesk-unread-badge';
        badge.setAttribute('aria-hidden', 'true');
        button.appendChild(badge);
      }
      badge.textContent = n > 99 ? '99+' : String(n);
    } else if (badge) {
      badge.remove();
    }
  }

  function syncLauncherUi() {
    if (!button) return;
    const open = messengerPanelOpen || webWidgetPanelOpen;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    let label = open ? cfg.ariaLabelClose || 'Close chat' : cfg.ariaLabel || 'Live chat';
    if (!open && lastUnreadCount > 0) {
      label += ', ' + lastUnreadCount + ' unread';
    }
    button.setAttribute('aria-label', label);
    refreshUnreadBadge();
  }

  function setUnread(count) {
    lastUnreadCount = Number(count) || 0;
    syncLauncherUi();
  }

  function handleLauncherClick() {
    if (typeof window.zE !== 'function') return;
    try {
      window.zE('messenger', messengerPanelOpen ? 'close' : 'open');
      return;
    } catch (_) { }
    try {
      window.zE('webWidget', webWidgetPanelOpen ? 'close' : 'open');
      webWidgetPanelOpen = !webWidgetPanelOpen;
      syncLauncherUi();
      if (webWidgetPanelOpen) {
        scheduleApplyFrameBottom();
      } else {
        clearMessengerFrameBottom();
      }
    } catch (_) { }
  }

  function createButton() {
    if (document.getElementById('ab-zendesk-custom-launcher')) return;
    ensureStyles();
    const btn = document.createElement('button');
    btn.id = 'ab-zendesk-custom-launcher';
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', cfg.ariaLabel || 'Live chat');
    const faceChat = document.createElement('span');
    faceChat.className = 'ab-zendesk-launcher-face ab-zendesk-launcher-face--chat';
    const img = document.createElement('img');
    img.src = iconUrl;
    img.alt = '';
    img.width = 60;
    img.height = 60;
    img.decoding = 'async';
    img.loading = 'lazy';
    faceChat.appendChild(img);
    const faceToggle = document.createElement('span');
    faceToggle.className = 'ab-zendesk-launcher-face ab-zendesk-launcher-face--toggle';
    faceToggle.setAttribute('aria-hidden', 'true');
    faceToggle.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="none" aria-hidden="true">' +
      '<path stroke="#fff" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" d="M8 10l4 4 4-4"/>' +
      '</svg>';
    btn.appendChild(faceChat);
    btn.appendChild(faceToggle);
    btn.addEventListener('click', handleLauncherClick);
    document.body.appendChild(btn);
    button = btn;
  }

  function wireMessengerOnce() {
    if (messengerWired || typeof window.zE !== 'function') return;
    try {
      window.zE('messenger:on', 'open', function () {
        messengerPanelOpen = true;
        syncLauncherUi();
        scheduleApplyFrameBottom();
      });
      window.zE('messenger:on', 'close', function () {
        messengerPanelOpen = false;
        clearMessengerFrameBottom();
        syncLauncherUi();
      });
      window.zE('messenger:on', 'unreadMessages', function (count) {
        setUnread(Number(count) || 0);
      });
      messengerWired = true;
    } catch (_) { }
  }

  function startZendeskFramePositionWatchers() {
    if (window.__abZendeskFrameWatchersStarted) return;
    window.__abZendeskFrameWatchersStarted = true;

    scheduleApplyFrameBottom();

    const pollUntil = Date.now() + 20000;
    const pollIv = window.setInterval(function () {
      if (Date.now() > pollUntil) {
        window.clearInterval(pollIv);
        return;
      }
      if (hasZendeskChatFrameCandidate()) {
        applyMessengerFrameBottom();
      }
    }, 400);

    if (typeof MutationObserver !== 'undefined' && document.body) {
      let moScheduled = false;
      function mutationAddsIframe(nodes) {
        for (let i = 0; i < nodes.length; i++) {
          const n = nodes[i];
          if (n.nodeType !== 1) continue;
          if (n.nodeName === 'IFRAME') return true;
          if (typeof n.querySelector === 'function' && n.querySelector('iframe')) return true;
        }
        return false;
      }
      const obs = new MutationObserver(function (mutations) {
        let hit = false;
        for (let m = 0; m < mutations.length; m++) {
          if (mutationAddsIframe(mutations[m].addedNodes)) {
            hit = true;
            break;
          }
        }
        if (!hit) return;
        if (moScheduled) return;
        moScheduled = true;
        window.requestAnimationFrame(function () {
          moScheduled = false;
          applyMessengerFrameBottom();
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  function tryInit() {
    if (typeof window.zE !== 'function') return;
    createButton();
    wireMessengerOnce();
    if (!window.__abZendeskFrameResizeBound) {
      window.__abZendeskFrameResizeBound = true;
      window.addEventListener('resize', onViewportResizeForFrame);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onViewportResizeForFrame);
      }
      startZendeskFramePositionWatchers();
    }
  }

  let attempts = 0;
  const iv = setInterval(function () {
    tryInit();
    if (typeof window.zE === 'function' || ++attempts > 400) clearInterval(iv);
  }, 75);
})();
